const ruins = document.querySelector('.ruins')

if (ruins) {
    const map = document.querySelector('.map-popup')
    const mapData = document.querySelector('.map__wrapper')

    ruins.addEventListener('click', (e) => {
        if (e.target.classList.contains('ruin__view-button')) {
            document.querySelectorAll('.ruin__view-button')
                .forEach( el => el.classList.remove('is-active'))
            e.target.classList.add('is-active')
            map.classList.remove('hidden')
        } 
        if (e.target.classList.contains('map-close')) {
            closeMap()
        }
        if (e.target.classList.contains('map-full')) {
            showFullscreenMap()
        }
    })

    function showFullscreenMap () {
        mapData.classList.toggle('fullscreen')
    }

    function closeMap() {
        mapData.classList.contains('fullscreen') && mapData.classList.remove('fullscreen')
        map.classList.add('hidden')

    }
}
